const spaceRe = /(\s+)/g;
const azRe = /([^a-z0-9-])/gi;

function strToUrlpath(str) {
  return str.replace(spaceRe, '-').replace(azRe, '').toLowerCase();
}

module.exports = strToUrlpath;
